import React from 'react';
import { Tab, Nav, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useSetTab } from '../../../services/hooks';
import TalentDataTable from './TalentDataTable';
import TalentDncDataTable from './TalentDncDataTable';

const EmployeeTalentTabs = ({ employee }) => {
  const location = useLocation();
  const [key, setKey] = useSetTab('capacitaciones', location, 'talentTab');

  return (
    <Tab.Container id="employee-talent-tabs" activeKey={key} onSelect={k => setKey(k)} mountOnEnter>
      <Row className="align-items-center mt-3 mb-3 mx-1">
        <Col>
          <Nav variant="pills" className="ab-pills">
            <Nav.Item>
              <Nav.Link eventKey="dnc">DNC</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="capacitaciones">Capacitaciones</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>

      <Tab.Content>
        <Tab.Pane eventKey="dnc">
          <TalentDncDataTable employeeId={employee.id} />
        </Tab.Pane>
        <Tab.Pane eventKey="capacitaciones">
          <TalentDataTable employeeId={employee.id} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default EmployeeTalentTabs;
